export default "__VITE_PUBLIC_ASSET__494a5d54__"